const professionalGames = [
    {   
        gameBanner: 'geometa', 
        gameName: 'Geometa', 
        releaseYear: 'May 2023', 
        releaseState: 'Released', 
        company: 'Ludus Studios',
        role: 'Unity Programmer',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.Inteceleri.Geometa',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'matematicando', 
        gameName: 'Matematicando', 
        releaseYear: ' May 2023', 
        releaseState: 'Released', 
        company: 'Ludus Studios',
        role: 'Unity Programmer',
        playStoreLink: 'https://play.google.com/store/apps/details?id=air.MatematicandoEducation',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'hydro', 
        gameName: 'Hydro Ambiental', 
        releaseYear: 'March 2023', 
        releaseState: 'Released', 
        company: 'Ludus Studios',
        role: 'Unity Programmer',
        playStoreLink: '',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: 'https://www.hydro.com/pt-BR/imprensa/noticias/2023/hydro-une-educacao-ambiental-e-inovacao-em-mina-de-bauxita/',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'trix', 
        gameName: 'Trix Battle Tactics', 
        releaseYear: 'March 2023', 
        releaseState: 'Cancelled', 
        company: 'Brais Games',
        role: 'Unity Programmer',
        playStoreLink: '',
        githubLink: '',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/trix-battle-tactics',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'alexia', 
        gameName: 'Alexia Trials', 
        releaseYear: 'October 2022', 
        releaseState: 'Released', 
        company: 'Brais Games',
        role: 'Unity Programmer',
        playStoreLink: '',
        githubLink: '',
        linkedinLink: '',
        itchLink: 'https://jerffesonj.itch.io/alexia-trials',
        youtubeLink: 'https://www.youtube.com/watch?v=wQxNF6t4T1A',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'hank', 
        gameName: "Hank'n Spank", 
        releaseYear: 'October 2021', 
        releaseState: 'Released', 
        company: 'Brais Games',
        role: 'Unity Programmer',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.BraisGames.HanknSpank',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'bubbli', 
        gameName: 'Bubbli Bash', 
        releaseYear: 'September 2021', 
        releaseState: 'Released', 
        company: 'Brais Games',
        role: 'Unity Programmer',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.BraisGames.Bubblibash',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'bit-draw', 
        gameName: 'Bit Draw', 
        releaseYear: 'July 2021', 
        releaseState: 'Released', 
        company: 'Brais Games',
        role: 'Unity Programmer',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.BraisGames.BitDraw',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
    {   
        gameBanner: 'renegado', 
        gameName: 'Renegado', 
        releaseYear: 'March 2021', 
        releaseState: 'Released', 
        company: 'Black Paladins',
        role: 'Unity Programmer & Game Designer',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.BlackPaladins.Renegado',
        githubLink: '',
        linkedinLink: '',
        itchLink: '',
        youtubeLink: '',
        siteLink: '',

        itchEmbedLink: '',
        itchWidth: '',
        itchHeight: '',
    },
];

export default professionalGames